<template>
    <div>
        <div class="a-fs-16 a-fw-700" v-if="showSwitch">电费信息</div>
        <el-form ref="form" :model="form" :rules="rules" label-position='left' label-width='140px' style="max-width: 1200px;">
            <le-switch label="是否启用电费配置" v-if="showSwitch" v-model="form.useElectric" :acValue="1" :inacValue="0"></le-switch>
            <div v-if="changeEleCompany">
                <el-row :gutter="72">
                    <el-col :span="10">
                        <el-form-item label="电费缴纳方" prop="companyId" >
                            <el-select v-model="form.companyId" placeholder="请选择" clearable @change='handleChangeCompanyId'>
                                <el-option v-for="item in electricBillPayCompanyListFilter"
                                    :key="item.targetCompanyId"
                                    :label="item.targetCompanyName"
                                    :value="item.targetCompanyId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <div v-else-if="form.useElectric">
                <el-row :gutter="72">
                    <el-col :span="10">
                        <el-form-item label="电费缴纳方" prop="companyId" >
                            <el-select v-model="form.companyId" placeholder="请选择" clearable @change='handleChangeCompanyId'>
                                <el-option v-for="item in electricBillPayCompanyListFilter"
                                    :key="item.targetCompanyId"
                                    :label="item.targetCompanyName"
                                    :value="item.targetCompanyId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="14">
                        <el-form-item label-width='130px' label='关联电费项目方式'>
                            <le-switch-btn style="padding: 0 !important" v-model="form.type" :options="typeOptions"></le-switch-btn>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="72" v-if="form.type == 2">
                    <el-col :span="12">
                        <el-form-item label="电费项目" prop="projectId" >
                            <div class="a-flex-rfsc">
                                <le-select-remote-search style="padding: 0" v-model="form.projectId" :options="optionsElectric" placeholder="请选择电费项目(可搜索)" />
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="72" v-if="form.type == 1">
                    <el-col :span="10">
                        <el-form-item label="电费类型" prop="electricFeeType" >
                            <el-select v-model="form.electricFeeType" placeholder="请选择">
                                <el-option v-for="item in electricFeeTypeDic"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    
                    <el-col :span="14">
                        <el-form-item label="电费收取方式" prop="chargeFeeType" >
                            <el-select v-model="form.chargeFeeType" placeholder="请选择" clearable @change='chargeFeeTypeChange'>
                                <el-option v-for="item in chargeFeeTypeDic"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="72" v-if="form.type == 1">
                    
                    <el-col :span="10">
                        <el-form-item label="电费价格" prop="unitPrice" >
                            <div class="a-flex-rfsc">
                                <el-input v-model="form.unitPrice" style="width:240px" maxlength="10" @input="form.unitPrice = util.checkMoney5(form.unitPrice)" placeholder="请输入电费价格">
                                    <template slot="append">元/kwh</template>
                                </el-input>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="14">
                        <el-form-item label="默认服务费用" prop='serviceUnitPrice'>
                            <div class="a-flex-rfsc">
                                <jd-input-price v-model="form.serviceUnitPrice" style="width:240px" maxlength="10"></jd-input-price>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="72" v-if="form.type == 1">
                    <el-col :span="10">
                        <el-form-item label="电费收款方" prop="chargePayeeType" >
                            <el-select v-model="form.chargePayeeType" placeholder="请选择" clearable :disabled='form.chargeFeeType == 2' @change='chargePayeeTypeChange'>
                                <el-option v-for="item in chargePayeeTypeDic"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="72" v-if="form.type == 1">
                    <el-col :span="24">
                        <el-form-item label="收款物业方" prop="propertyList" v-if="form.chargePayeeType == 2">
                            <el-button type="primary" size='mini'  @click="addProperty">添加物业</el-button>
                            <div class="a-flex-rfsc a-mb-05" v-for="(item,index) in form.propertyList" :key="index">
                                <le-select-remote-search 
                                    style="padding: 0 !important"
                                    v-model="item.propertyId" 
                                    :options="optionsProperty" 
                                    :defaultOptions='defaultPropertyList'
                                    placeholder="请选择（可输入搜索）" />
                                <span class="a-mlr-12">，物业占比：</span>
                                <el-input v-model="item.rate" maxlength="24" style="width:120px" placeholder="请输入">
                                    <template slot="suffix">%</template>
                                </el-input>
                                <el-tooltip class="devList-btn" effect="dark" content="删除" placement="top" >
                                    <img src="../../assets/icon/option-del-circle.png" @click="delProperty(index)" class="a-wh-16 a-mlr-12" />
                                </el-tooltip>
                                <el-tooltip class="devList-btn" effect="dark" content="添加" placement="top" >
                                    <img src="../../assets/icon/option-add-circle.png" @click="addProperty" class="a-wh-16 a-mlr-12" />
                                </el-tooltip>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            
        </el-form>
    </div>
</template>

<script>
import util from '@/utils/util'
export default {
    data () {
        var checkPropertyList = async (rule, value, callback) => {
            let errorText = await this.checkRules(this.form.propertyList)
            if(errorText){
                callback(new Error(errorText))
            }else{
                callback()
            }
        };
        var checkServiceUnitPrice = (rule, value, callback) => {
            if(value === '0' || (value <= 0 && value !== '')) {
                callback(new Error('若填写默认服务费，则默认服务费须大于0'))
            }else {
                callback()
            }
        };
        return {
            util,
            rules: {
                companyId: [{required: true, message:'请选择电费缴纳方', trigger: 'change'}],
                electricFeeType: [{required: true, message:'请选择电费类型', trigger: 'change'}],//
                chargeFeeType: [{required: true, message:'请选择电费收取方式', trigger: 'change'}],//电费收取方式:1:预充值,2先用后付
                chargePayeeType: [{required: true, message:'请选择电费收取方', trigger: 'change'}],//电费收款方类型:1:App自交,2物业代收
                unitPrice: [{required: true, message:'请填写电费单价', trigger: 'blur'}],//电费单价
                propertyList: [{ validator: checkPropertyList, trigger: 'change' }],
                serviceUnitPrice: [{ validator: checkServiceUnitPrice, trigger: 'blur' }],
                projectId: [{required: true, message:'请选择电费项目', trigger: 'change'}],
            },
            typeOptions: [
                {
                    label: '创建新的电费项目',
                    value: 1
                }, {
                    label: '关联现有的电费项目',
                    value: 2
                }
            ],
            chargeFeeTypeDic: [],
            chargePayeeTypeDic: [],
            optionsProperty: {
                url: this.$Config.apiUrl.propertyCompanyfilterForIncome,
                method: "post",
                params: {
                    currentCompanyId: ''
                },
                showLoading: false,
                labelKey: "name",
                valueKey: "id",
                searchKey: "name",
                pageSize: 500
            },
            optionsElectric: {
                url: this.$Config.apiUrl.electricFilter,
                method: "post",
                params: {
                    currentCompanyId: ''
                },
                showLoading: false,
                labelKey: "name",
                valueKey: "id",
                searchKey: "name",
                pageSize: 100
            },
            defaultPropertyList: [],
            electricFeeTypeDic: []
        }
    },
    computed: {
        electricBillPayCompanyListFilter () {
            return this.electricBillPayCompanyList.map(item=>{
                return {
                    ...item,
                    targetCompanyId: item.targetCompanyInfo.value,
                    targetCompanyName: item.targetCompanyInfo.label
                }
            })
        }
    },
    props: {
        form: {
            default: ()=>{
                return {}
            }
        },
        electricBillPayCompanyList: {
            default: () =>{
                return []
            }
        },
        showSwitch: {
            default: true,
            type: Boolean
        },
        changeEleCompany: {
            default: false,
            type: Boolean
        }
    },
    watch: {
        form: {
            deep: true,
            handler (val) {
                this.$emit('update:form', val)
            }
        },
        electricBillPayCompanyList: {
            deep: true,
            immediate: true,
            handler (val) {
                if(val && val.length) {
                    let arr = [...val]
                    arr.sort((a, b)=>{
                        return b.rate - a.rate
                    })
                    this.$set(this.form, 'companyId', arr[0].targetCompanyInfo.value);
                    this.optionsElectric.params.currentCompanyId = arr[0].targetCompanyInfo.value
                    this.optionsProperty.params.currentCompanyId = arr[0].targetCompanyInfo.value
                    this.form.projectId = ''
                }
            }
        }
    },
    mounted () {
        this.$getDic('chargeFeeType','select').then(res=>{ this.chargeFeeTypeDic = res; })
        this.$getDic('chargePayeeType','select').then(res=>{ this.chargePayeeTypeDic = res; })
        this.$getDic('electricFeeType','select').then(res=>{ this.electricFeeTypeDic = res; })
    },
    methods: {
        // 电费收取方式更改
        chargeFeeTypeChange () {
            if(this.form.chargeFeeType == 2) {
                this.form.chargePayeeType = '2'
            }
        },
        // 电费收款方修改
        chargePayeeTypeChange () {
            this.form.propertyList = []
        },
        // 删除物业收款方
        delProperty (index) {
            this.form.propertyList.splice(index,1)
            this.$refs['form'].validateField(['propertyList'])
        },
        // 添加物业收款方
        addProperty () {
            this.form.propertyList.push({
                propertyId: '',
                rate: ''
            })
        },
        handleChangeCompanyId () {
            this.optionsElectric.params.currentCompanyId = this.form.companyId
            this.optionsProperty.params.currentCompanyId = this.form.companyId
            this.form.projectId = ''
            this.form.propertyList = []
        },
        submit () {
            return new Promise ((resolve, reject)=>{
                let reqData = {
                    ...this.form
                }
                reqData.propertyList = reqData.propertyList.map(item=>{
                    return {
                        ...item,
                        rate: Number((item.rate*100).toFixed(0))
                    }
                })
                this.$Axios._post({
                    url: this.$Config.apiUrl.electricEdit,
                    method: "post",
                    params: {
                        ...reqData,
                        unitPrice: this.$decimal.decimal_ride(reqData.unitPrice, 100),
                        serviceUnitPrice: reqData.serviceUnitPrice ? this.$decimal.decimal_ride(reqData.serviceUnitPrice, 100) : '',
                    }
                })
                .then(res=>{
                    if (res.result.code == 0) {
                        resolve(true)
                        this.$emit('submit', 'success')
                    } else {
                        resolve(false)
                    }
                })
                .catch(err=>{
                    resolve(false)
                })
            })
        },
        handleValidate () {
            return new Promise ((resolve, reject)=>{
                if(!this.form.useElectric) {
                    resolve(true)
                }else {
                    this.$refs['form'].validate((valid) => {
                        if (valid) {
                            resolve(true)
                        }else{
                            resolve(false)
                        }
                    })
                }
            })
        },
        checkRules (datas) {
            return new Promise((resolve, reject) => {
                if(datas.length && datas){
                    let rateAll = 0
                    let propertyId = []
                    for (let index = 0; index < datas.length; index++) {
                        const item = datas[index];
                        if(!item.propertyId){
                            resolve('请选择物业')
                            return
                        }
                        if(!item.rate || item.rate == 0 || item.rate == '0'){
                            resolve('请填写物业收款占比')
                            return
                        }
                        rateAll += Number(item.rate)
                        propertyId.push(item.propertyId)
                    }
                    if(new Set(propertyId).size !== propertyId.length) {
                        resolve('不可重复选择物业收款方')
                    }else if(rateAll != 100) {
                        resolve('物业收款占比之和必须等于100%')
                    }else {
                        resolve()
                    }
                }else{
                    resolve()
                }
            })
        },
    }
}
</script>

<style lang='scss' scoped>

</style>